import { render, staticRenderFns } from "./PageListItem.vue?vue&type=template&id=0213bb76&scoped=true&"
import script from "./PageListItem.vue?vue&type=script&lang=js&"
export * from "./PageListItem.vue?vue&type=script&lang=js&"
import style0 from "./PageListItem.vue?vue&type=style&index=0&id=0213bb76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0213bb76",
  null
  
)

export default component.exports